module.exports = __webpack_public_path__ + "static/media/about-beryslaw.35c89e84.mp4";